import { render, staticRenderFns } from "./localCenter.vue?vue&type=template&id=4925efc1&"
import script from "./localCenter.vue?vue&type=script&lang=js&"
export * from "./localCenter.vue?vue&type=script&lang=js&"
import style0 from "./localCenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports